import { useContext } from 'react'
import logo from '../../assets/images/logo.svg'
import profile from '../../assets/images/profile.png'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { ThemeContext } from '../../contexts/ThemeContext';
import { conceptualApps, businessToolsModules } from '../AppData';

export default function Header() {
    const location = useLocation();
    const navigate = useNavigate();
    const { theme, changeTheme, font, changeFont, breadcrumbs, toggleBreadcrumbs, radius0, toggleRadius0, shadowActive, toggleShadow, bsTheme, changeBsTheme, title } = useContext(ThemeContext)

    // Check if user is on authentication pages (sign-in, OTP, password setup)
    const isAuthPage = () => {
        const path = location.pathname;
        return path === '/' || 
               path === '/signin' || 
               path === '/verify-otp' || 
               path === '/setup-password' ||
               path === '/password-entry';
    };

    // Handle logout functionality
    const handleLogout = () => {
        // Clear all authentication data
        localStorage.removeItem('isAuthenticated');
        localStorage.removeItem('userPassword');
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        
        // Navigate to sign-in page
        navigate('/');
    };

    // Don't show header on authentication pages
    if (isAuthPage()) {
        return null;
    }

    return (
        <>
            <header className="header sticky-top" id="header">
                <div className="container-fluid px-2 px-md-4">
                    <div className="d-flex align-items-center justify-content-between py-md-3 py-2">
                        <div className="logo">
                            <Link to="/home">
                                <img src={logo} alt="Logo" className="img-fluid" />
                                <small className="d-block text-uppercase text-secondary text-truncate">{title}</small>
                            </Link>
                        </div>
                        <div className="right-header d-flex flex-fill align-items-center justify-content-between">
                            <Link to="#" className="btn p-0 ms-3 hover-svg" aria-label='Dashboard Menu' data-bs-toggle="modal" data-bs-target="#Menu_Grid">
                                <svg width="28" height="28" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M5.27148 5H12.7296V12.5H5.27148V5Z" />
                                    <path d="M17.7017 5H25.1598V12.5H17.7017V5Z" />
                                    <path d="M5.27148 17.5H12.7296V25H5.27148V17.5Z" />
                                    <path d="M17.7017 21.25C17.7017 22.2446 18.0945 23.1984 18.7939 23.9017C19.4932 24.6049 20.4417 25 21.4307 25C22.4197 25 23.3682 24.6049 24.0676 23.9017C24.7669 23.1984 25.1598 22.2446 25.1598 21.25C25.1598 20.2554 24.7669 19.3016 24.0676 18.5983C23.3682 17.8951 22.4197 17.5 21.4307 17.5C20.4417 17.5 19.4932 17.8951 18.7939 18.5983C18.0945 19.3016 17.7017 20.2554 17.7017 21.25Z" />
                                </svg>
                            </Link>
                            <ul className="nav navbar-right d-flex gap-lg-4 gap-2 align-items-center ms-auto">
                                <li className="d-none align-items-center d-sm-flex">
                                    <Link className="nav-link p-1 px-2 d-none d-md-block" to="#">Documentation</Link>
                                    <Link className="nav-link p-1 px-2" to="#">Help</Link>
                                </li>
                                <li className="d-flex gap-2 align-items-center">
                                    <div className="dropdown">
                                        <Link className="nav-link dropdown-toggle hover-svg" to="#" aria-label='Notification' role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            <span className="bullet-dot bg-primary animation-blink"></span>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M10 5a2 2 0 0 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6" />
                                                <path d="M9 17v1a3 3 0 0 0 6 0v-1" />
                                                <path d="M21 6.727a11.05 11.05 0 0 0 -2.794 -3.727" />
                                                <path d="M3 6.727a11.05 11.05 0 0 1 2.792 -3.727" />
                                            </svg>
                                        </Link>
                                        <div className="dropdown-menu p-0 notifications shadow-lg rounded-4 overflow-hidden">
                                            <div className="card border-0">
                                                <div className="card-header d-flex justify-content-between align-items-center p-4 border-bottom-0">
                                                    <h6 className="card-title mb-0">Notifications Center</h6>
                                                    <span className="badge bg-primary">19</span>
                                                </div>
                                                <ul className="list-unstyled list-group list-group-custom mb-0 rounded-0 li_animate">
                                                    <li className="list-group-item d-flex border-end-0 border-start-0">
                                                        <div className="d-flex flex-column flex-grow-1 p-2 overflow-hidden">
                                                            <h6 className="mb-0 fw-medium">
                                                                <Link to="#">7 New Feedback</Link>
                                                                <small className="float-end text-muted">Today</small>
                                                            </h6>
                                                            <small className="d-block text-truncate">It will give a smart finishing to your site</small>
                                                        </div>
                                                    </li>
                                                    <li className="list-group-item d-flex border-end-0 border-start-0">
                                                        <div className="d-flex flex-column flex-grow-1 p-2 overflow-hidden">
                                                            <h6 className="mb-0 fw-medium">
                                                                <Link to="#">New User</Link>
                                                                <small className="float-end text-muted">10:45</small>
                                                            </h6>
                                                            <small className="d-block text-truncate">I feel great! Thanks team</small>
                                                        </div>
                                                    </li>
                                                    <li className="list-group-item d-flex border-end-0 border-start-0">
                                                        <div className="d-flex flex-column flex-grow-1 p-2 overflow-hidden">
                                                            <h6 className="mb-0 fw-medium">
                                                                <Link to="#">Server Warning</Link>
                                                                <small className="float-end text-muted">10:50</small>
                                                            </h6>
                                                            <small className="d-block text-truncate">Your connection is not private</small>
                                                            <div className="mt-2 d-flex gap-2 align-items-center">
                                                                <Link to="#" className="btn btn-sm rounded-pill bg-primary text-white">Accept</Link>
                                                                <Link to="#" className="btn btn-sm rounded-pill btn-dark text-white">Decline</Link>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li className="list-group-item d-flex border-end-0 border-start-0">
                                                        <div className="d-flex flex-column flex-grow-1 p-2 overflow-hidden">
                                                            <h6 className="mb-0 fw-medium">
                                                                <Link to="#">Issue Fixed</Link>
                                                                <small className="float-end text-muted">11:05</small>
                                                            </h6>
                                                            <small className="d-block text-truncate">WE have fix all Design bug with Responsive</small>
                                                        </div>
                                                    </li>
                                                    <li className="list-group-item d-flex border-end-0 border-start-0">
                                                        <div className="d-flex flex-column flex-grow-1 p-2 overflow-hidden">
                                                            <h6 className="mb-0 fw-medium">
                                                                <Link to="#">7 New Orders</Link>
                                                                <small className="float-end text-muted">11:35</small>
                                                            </h6>
                                                            <small className="d-block text-truncate">You received a new order from Tina.</small>
                                                        </div>
                                                    </li>
                                                </ul>
                                                <div className="card-body py-2">
                                                    <Link to="#" className="btn btn-link px-2">View all notifications</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-md-inline-block d-none dropdown">
                                        <Link className="nav-link dropdown-toggle hover-svg" to="#" aria-label='Language' role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M4 5h7" />
                                                <path d="M9 3v2c0 4.418 -2.239 8 -5 8" />
                                                <path d="M5 9c0 2.144 2.952 3.908 6.7 4" />
                                                <path d="M12 20l4 -9l4 9" />
                                                <path d="M19.1 18h-6.2" />
                                            </svg>
                                        </Link>
                                        <ul className="dropdown-menu p-2 p-xl-3 language shadow-lg rounded-4 li_animate">
                                            <li className="mb-1"><Link className="dropdown-item rounded-pill active" to="#">English</Link></li>
                                            <li className="mb-1"><Link className="dropdown-item rounded-pill" to="#">French</Link></li>
                                            <li className="mb-1"><Link className="dropdown-item rounded-pill" to="#">German</Link></li>
                                        </ul>
                                    </div>
                                    <div className="dropdown">
                                        <Link className="dropdown-toggle d-flex" to="#" id="bd-theme" aria-label='Dark Light Mode' data-bs-toggle="dropdown" aria-expanded="false">
                                            <svg className="theme-icon-active" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><use
                                                href={
                                                    bsTheme === "light"
                                                        ? "#sun-fill"
                                                        : bsTheme === "dark"
                                                            ? "#moon-stars-fill"
                                                            : "#circle-half"
                                                }
                                            /></svg>
                                        </Link>
                                        <ul className="dropdown-menu p-2 p-xl-3 language shadow-lg rounded-4 li_animate dropdown-menu-end" aria-labelledby="bd-theme">
                                            <li className="mb-1"><Link onClick={(e) => { e.preventDefault(); changeBsTheme('light') }} className={`dropdown-item rounded-pill ${bsTheme === 'light' ? 'active' : ''}`} data-bs-theme-value="light"><svg className="me-2" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><use href="#sun-fill"></use></svg> Light</Link></li>
                                            <li className="mb-1"><Link onClick={(e) => { e.preventDefault(); changeBsTheme('dark') }} className={`dropdown-item rounded-pill ${bsTheme === 'dark' ? 'active' : ''}`} data-bs-theme-value="dark"><svg className="me-2" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><use href="#moon-stars-fill"></use></svg> Dark</Link></li>
                                            <li className="mb-1"><Link onClick={(e) => { e.preventDefault(); changeBsTheme('auto') }} className={`dropdown-item rounded-pill ${bsTheme === 'auto' ? 'active' : ''}`} data-bs-theme-value="auto"><svg className="me-2" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><use href="#circle-half"></use></svg> Auto</Link></li>
                                        </ul>
                                        <svg xmlns="http://www.w3.org/2000/svg" style={{ display: "none" }}>
                                            <symbol id="sun-fill" viewBox="0 0 24 24">
                                                <path d="M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" />
                                                <path d="M3 12h1m8 -9v1m8 8h1m-9 8v1m-6.4 -15.4l.7 .7m12.1 -.7l-.7 .7m0 11.4l.7 .7m-12.1 -.7l-.7 .7" />
                                            </symbol>
                                            <symbol id="moon-stars-fill" viewBox="0 0 24 24">
                                                <path d="M12 3c.132 0 .263 0 .393 0a7.5 7.5 0 0 0 7.92 12.446a9 9 0 1 1 -8.313 -12.454z" />
                                                <path d="M17 4a2 2 0 0 0 2 2a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2a2 2 0 0 0 2 -2" />
                                                <path d="M19 11h2m-1 -1v2" />
                                            </symbol>
                                            <symbol id="circle-half" viewBox="0 0 24 24">
                                                <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                                                <path d="M12 3l0 18" />
                                                <path d="M12 9l4.65 -4.65" />
                                                <path d="M12 14.3l7.37 -7.37" />
                                                <path d="M12 19.6l8.85 -8.85" />
                                            </symbol>
                                        </svg>
                                    </div>
                                    <div>
                                        <Link className="d-flex hover-svg" aria-label='Theme Setting' data-bs-toggle="offcanvas" to="#ThemeSettings" role="button" aria-controls="ThemeSettings">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M12 21a9 9 0 0 1 0 -18c4.97 0 9 3.582 9 8c0 1.06 -.474 2.078 -1.318 2.828c-.844 .75 -1.989 1.172 -3.182 1.172h-2.5a2 2 0 0 0 -1 3.75a1.3 1.3 0 0 1 -1 2.25" />
                                                <path d="M8.5 10.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                                                <path d="M12.5 7.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                                                <path d="M16.5 10.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                                            </svg>
                                        </Link>
                                    </div>
                                </li>
                                <li className="p-2 pe-0">
                                    <div className="dropdown">
                                        <button className="btn dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            <span className="profile-dropdown d-flex align-items-center">
                                                <img className="rounded-circle border border-white shadow" src={profile} width="30" height="30" alt="Profile" />
                                                <span className="h6 mb-0 ms-1 fw-normal nav-link p-0 d-none d-lg-block">Allie Grater</span>
                                            </span>
                                        </button>
                                        <div className="dropdown-menu rounded-4 shadow p-0 overflow-hidden">
                                            <div className="card border-0 w240 overflow-hidden">
                                                <div className="card-body">
                                                    <h5 className="mb-1">Allie Grater</h5>
                                                    <p>allie.grater@gmail.com</p>
                                                    {/* Updated Logout Button */}
                                                    <button 
                                                        className="btn btn-primary text-uppercase w-100 rounded-pill"
                                                        onClick={handleLogout}
                                                    >
                                                        Sign out
                                                    </button>
                                                </div>
                                                <div className="list-group m-2">
                                                    <Link className="list-group-item rounded-pill list-group-item-action border-0" to="#">Settings</Link>
                                                    <Link className="list-group-item rounded-pill list-group-item-action border-0" to="#">My Todo</Link>
                                                    <Link className="list-group-item rounded-pill list-group-item-action border-0" to="#">My Projects</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </header>

            {/* Menu Grid Modal */}
            <div className="modal fade" id="Menu_Grid" tabIndex="-1" aria-labelledby="Menu_GridLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-xl">
                    <div className="modal-content border-0 bg-transparent">
                        <div className="modal-body p-2">
                            <div className="container">
                                <div className="row">
                                    {/* Apps Section */}
                                    <div className="col-xl-9 col-md-8 col-12">
                                        <div className="row g-2">
                                            {conceptualApps.map((app, index) => (
                                                <div key={index} className="col-xl-2 col-md-3 col-4">
                                                    <div className="app-menu-item d-flex flex-column align-items-center justify-content-center p-3 rounded-3">
                                                        <div className="app-icon mb-2">
                                                            <img src={app.icon} alt={app.name} className="img-fluid" />
                                                        </div>
                                                        <span className="app-name text-center small fw-medium">{app.name}</span>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    {/* Tools Section */}
                                    <div className="col-xl-3 col-md-4 col-12 mt-md-0 mt-2">
                                        <div className="tools-section p-3 rounded-3">
                                            <h6 className="mb-3">Business Tools</h6>
                                            <div className="row g-2">
                                                {businessToolsModules.map((tool, index) => (
                                                    <div key={index} className="col-md-6 col-4">
                                                        <div className="tool-item d-flex flex-column align-items-center justify-content-center p-2 rounded-2">
                                                            <div className="tool-icon mb-1">
                                                                <img src={tool.icon} alt={tool.name} className="img-fluid" />
                                                            </div>
                                                            <span className="tool-name text-center x-small">{tool.name}</span>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Theme Settings Offcanvas */}
            <div className="offcanvas offcanvas-end" tabIndex="-1" id="ThemeSettings" aria-labelledby="ThemeSettingsLabel">
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title" id="ThemeSettingsLabel">Theme Settings</h5>
                    <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <div className="offcanvas-body">
                    <div className="settings-section mb-4">
                        <h6 className="mb-3">Theme Mode</h6>
                        <div className="d-flex gap-2">
                            <button 
                                className={`btn ${bsTheme === 'light' ? 'btn-primary' : 'btn-outline-primary'}`}
                                onClick={() => changeBsTheme('light')}
                            >
                                Light
                            </button>
                            <button 
                                className={`btn ${bsTheme === 'dark' ? 'btn-primary' : 'btn-outline-primary'}`}
                                onClick={() => changeBsTheme('dark')}
                            >
                                Dark
                            </button>
                            <button 
                                className={`btn ${bsTheme === 'auto' ? 'btn-primary' : 'btn-outline-primary'}`}
                                onClick={() => changeBsTheme('auto')}
                            >
                                Auto
                            </button>
                        </div>
                    </div>
                    
                    <div className="settings-section mb-4">
                        <h6 className="mb-3">Font Size</h6>
                        <div className="d-flex gap-2">
                            <button 
                                className={`btn ${font === 'small' ? 'btn-primary' : 'btn-outline-primary'}`}
                                onClick={() => changeFont('small')}
                            >
                                Small
                            </button>
                            <button 
                                className={`btn ${font === 'medium' ? 'btn-primary' : 'btn-outline-primary'}`}
                                onClick={() => changeFont('medium')}
                            >
                                Medium
                            </button>
                            <button 
                                className={`btn ${font === 'large' ? 'btn-primary' : 'btn-outline-primary'}`}
                                onClick={() => changeFont('large')}
                            >
                                Large
                            </button>
                        </div>
                    </div>
                    
                    <div className="settings-section mb-4">
                        <h6 className="mb-3">UI Options</h6>
                        <div className="form-check form-switch mb-2">
                            <input 
                                className="form-check-input" 
                                type="checkbox" 
                                role="switch" 
                                id="breadcrumbsSwitch"
                                checked={breadcrumbs}
                                onChange={toggleBreadcrumbs}
                            />
                            <label className="form-check-label" htmlFor="breadcrumbsSwitch">
                                Show Breadcrumbs
                            </label>
                        </div>
                        <div className="form-check form-switch mb-2">
                            <input 
                                className="form-check-input" 
                                type="checkbox" 
                                role="switch" 
                                id="radiusSwitch"
                                checked={radius0}
                                onChange={toggleRadius0}
                            />
                            <label className="form-check-label" htmlFor="radiusSwitch">
                                Rounded Corners
                            </label>
                        </div>
                        <div className="form-check form-switch mb-2">
                            <input 
                                className="form-check-input" 
                                type="checkbox" 
                                role="switch" 
                                id="shadowSwitch"
                                checked={shadowActive}
                                onChange={toggleShadow}
                            />
                            <label className="form-check-label" htmlFor="shadowSwitch">
                                Shadows
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}